// Router links for Navigation.vue
const routePoint = [
  {
    name: 'Dashboard',
    path: '/',
    icon: 'ImageIcon'
  },
  {
    name: 'Orders',
    path: '/orders',
    icon: 'ClipboardIcon'
  }
]

export default routePoint
